import { render, staticRenderFns } from "./sizeInpEX.vue?vue&type=template&id=288000a9&scoped=true&"
import script from "./sizeInpEX.vue?vue&type=script&lang=js&"
export * from "./sizeInpEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288000a9",
  null
  
)

export default component.exports